export const MAIN = "#B3AF8F";
export const MAIN_BACKGROUND = "#3B5249";

export const SECONDARY = '#eea7a6'
export const SECONDARY_BACKGROUND = '#474044'